import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'views/Root';
import { GlobalProvider } from '../src/context/GobalState';
import { BrowserRouter } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
const nonce = __webpack_nonce__; // This will now be available - webpack
const muiCache = createCache({
  key: 'mui',
  nonce: nonce, // Use the nonce here
});
ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <BrowserRouter>
        <StyleSheetManager nonce={nonce}>
          <CacheProvider value={muiCache}>
            <Root />
          </CacheProvider>
        </StyleSheetManager>
      </BrowserRouter>
    </GlobalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
